"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var HelpCircle = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 Z M12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 C16.418278,20 20,16.418278 20,12 C20,7.581722 16.418278,4 12,4 Z M12,16 L12,17 L11,17 L11,16 L12,16 Z M12,7 C13.4524268,7 14.3619538,7.61120214 14.7671591,8.61971312 C14.9534463,9.08336122 15,9.48165406 15,10 C15,11.3274771 14.5859629,11.9323406 13.5481338,12.5695484 L13.2519355,12.7443895 C12.3582639,13.2656979 12.0359431,13.6809453 12.0028879,14.7958291 L12,15 L11,15 C11,13.4124467 11.471025,12.6695635 12.5773331,11.9832343 L12.8672729,11.811356 C13.7592849,11.2934935 14,10.9824545 14,10 C14,9.5999786 13.9658181,9.3075336 13.8392549,8.99253178 C13.5866863,8.36391667 13.0451436,8 12,8 C10.9548564,8 10.4133137,8.36391667 10.1607451,8.99253178 C10.0552758,9.2550333 10.0139601,9.50187035 10.0031179,9.80835153 L10,10 L10,11 L9,11 L9,10 C9,9.48165406 9.04655371,9.08336122 9.23284089,8.61971312 C9.63804619,7.61120214 10.5475732,7 12,7 Z" })));
};
HelpCircle.displayName = 'HelpCircle';
exports.default = HelpCircle;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=HelpCircle.js.map